module.exports = "/assets/71cd5f39f3e67e9ef2fb04c7eff7bdd7.png";